import React from "react";
import styles from "./ShortenAddress.module.sass";

const ShortenAddress = ({className = styles.number, address}) => {

    const shortenAddress = (address, chars = 7) => {
        return `${address.substring(0, chars + 2)}...${address.substring(42 - chars)}`
    };

    return (
        <span className={className}>{shortenAddress(address)}</span>
    );
}

export default ShortenAddress;
